import React from 'react';

import { observer } from 'mobx-react';
import { TitleWithDescription, InfoBox } from '@infoods/lifebase-ui';

import classes from './CoachCard.module.scss';
import { CoachNameBlock } from './CoachNameBlock/CoachNameBlock';
import {
  ConsultationType,
  CONSULTATION_TYPE,
} from '../../../../shared/constants/coach/consultationType';

type Coach = {
  coachId: number;
  entityId: number;
  coachName: string;
  coachAvatar: string | null;
  entityName: string;
  distance?: number;
};

type CoachCardProps = {
  coachInfo: Coach;
  consultationType: ConsultationType | null;
};

const CoachCard = observer(({ coachInfo, consultationType }: CoachCardProps) => {
  return (
    <InfoBox title="Your coach">
      <div className={classes.container}>
        <CoachNameBlock
          avatarUrl={coachInfo.coachAvatar}
          name={coachInfo.coachName}
          distance={coachInfo.distance}
        />
        <TitleWithDescription
          className={classes.infoBlock}
          title="Business Name"
          description={coachInfo.entityName}
          titleFont="body-14-bold"
          descriptionColor="main-black"
        />
        {consultationType === CONSULTATION_TYPE.REMOTE && (
          <TitleWithDescription
            className={classes.infoBlock}
            title="Collaboration"
            description="To work with a coach remotely"
            titleFont="body-14-bold"
            descriptionColor="main-black"
          />
        )}
      </div>
    </InfoBox>
  );
});

export { CoachCard };
